import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ViewType } from "../../redux/alerts";
import { monitorsReady } from "../../redux/alerts/selectors";
import { allDepartments } from "../../redux/organization/selectors";
import {
  residentsReady,
  residentsSlicedBySelectedMonitorNode,
} from "../../redux/residents/selectors";
import { IAppState } from "../../redux/types";
import ConditionalPreloader, { Preloader } from "../preloader/Preloaders";
import NotificationContent from "./NotificationContent";
import StatusContent from "./StatusContent";
import "./styles.scss";

const MonitorContent = ({
  callback,
}: {
  callback: (...args: any) => void;
}): JSX.Element => {
  const { view } = useSelector((state: IAppState) => state.alerts.settings);
  const residentsLoaded = useSelector(residentsReady);
  const monitorLoaded = useSelector(monitorsReady);
  const residents = useSelector(residentsSlicedBySelectedMonitorNode);

  const canStartWork = useSelector(allDepartments).length > 0;
  const contentRef = useRef(null);

  const history = useHistory();

  // return <EmptyViewStatus emptyOrg={false} />;
  if (!canStartWork) return <Preloader />;
  // if (residents.length === 0 && residentsLoaded)
  //   return <ConditionalPreloader />;
  if (!monitorLoaded) return <Preloader />;

  return (
    <div
      className={`content ${
        view === ViewType.Status ? "monitor-status" : "monitor-alerts"
      } `}
      ref={contentRef}
      // onScroll={onMouseScroll}
    >
      <div className="flex-center" style={{ paddingBottom: "8px" }}>
        <button
          className="btn btn-icon nav-menu"
          onClick={() => history.push("/profile")}
        >
          <i className="icon-nav-settings" />
        </button>
      </div>
      {view === ViewType.Status ? (
        <StatusContent callback={callback} />
      ) : (
        <NotificationContent callback={callback} />
      )}
    </div>
  );
};

export default React.memo(MonitorContent);
